<!--网站首页-->
<template class="home">
  <div style="font-family: Alibaba">
    <!--PC端-->
    <div class="PC_box">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component class="index" :is='components.tail'></component>
        </keep-alive>
      </div>

      <!--导航图-->
      <div>
        <el-carousel height="34vw" class='carousel_class'>
          <el-carousel-item v-for='item in carouselList' :key='item.id'>
<!--            <div @click='daohang(item)'>-->
              <el-image
                style="width: 100%;height: 34vw"
                v-if='item.fullPathUrl != null'
                :src='item.fullPathUrl'
              />
<!--            </div>-->
          </el-carousel-item>
        </el-carousel>
      </div>

      <!--零碳海洋-->
      <keep-alive>
        <component :is='components.pcModuleOne'></component>
      </keep-alive>

      <!--产品展示-->
      <keep-alive>
        <component :is='components.pcModuleTwo'></component>
      </keep-alive>

      <!--采集产品-->
      <keep-alive>
        <component :is='components.pcModuleThree'></component>
      </keep-alive>

      <!--解决方案-->
      <keep-alive>
        <component :is='components.pcModuleFour'></component>
      </keep-alive>

      <!--资环行动-->
      <keep-alive>
        <component :is='components.pcModuleFive'></component>
      </keep-alive>

      <!--插入尾部-->
      <div>
        <keep-alive>
          <component  :is='components.tail1'></component>
        </keep-alive>
      </div>
    </div>

    <!--手机端-->
    <div class="mobile_box">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component :is='components.tail'></component>
        </keep-alive>
      </div>

      <div class='paddingS'>
        <!--占位div-->
        <div style='height: 72px'></div>

        <!--导航图-->
        <div class="navigationmap">
          <el-carousel>
            <el-carousel-item v-for='item in carouselList' :key='item.id'>
<!--              <div @click='daohang(item)'>-->
                <el-image
                  v-if='item.fullPathUrl != null'
                  :src='item.fullPathUrl'
                />
<!--              </div>-->
            </el-carousel-item>
          </el-carousel>
        </div>

        <!--零碳海洋-->
        <keep-alive>
          <component :is='components.mpModuleOne'></component>
        </keep-alive>

        <!--产品展示-->
        <keep-alive>
          <component :is='components.mpModuleTwo'></component>
        </keep-alive>

        <!--采集产品-->
        <keep-alive>
          <component :is='components.mpModuleThree'></component>
        </keep-alive>

        <!--解决方案-->
        <keep-alive>
          <component :is='components.mpModuleFour'></component>
        </keep-alive>

        <!--资环行动-->
        <keep-alive>
          <component :is='components.mpModuleFive'></component>
        </keep-alive>
      </div>

      <!--插入尾部-->
      <div>
        <keep-alive>
          <component  :is='components.tail1'></component>
        </keep-alive>
      </div>
    </div>

  </div>
</template>

<script>
import { findBanner } from '@/api/zh'
import header from '../components/header.vue'
import footer from '../components/footer.vue'
import pcModuleOne from '../components/pcModule1.vue'
import pcModuleTwo from '../components/pcModule2.vue'
import pcModuleThree from '../components/pcModule3.vue'
import pcModuleFour from '../components/pcModule4.vue'
import pcModuleFive from '../components/pcModule5.vue'
import mpModuleOne from '../components/mpModule1.vue'
import mpModuleTwo from '../components/mpModule2.vue'
import mpModuleThree from '../components/mpModule3.vue'
import mpModuleFour from '../components/mpModule4.vue'
import mpModuleFive from '../components/mpModule5.vue'
import axios from 'axios'
export default {
  data () {
    return {
      components: {
        tail: header,
        tail1: footer,
        pcModuleOne: pcModuleOne,
        pcModuleTwo: pcModuleTwo,
        pcModuleThree: pcModuleThree,
        pcModuleFour: pcModuleFour,
        pcModuleFive: pcModuleFive,
        mpModuleOne: mpModuleOne,
        mpModuleTwo: mpModuleTwo,
        mpModuleThree: mpModuleThree,
        mpModuleFour: mpModuleFour,
        mpModuleFive: mpModuleFive
      },
      player: null,
      options: {
        controls: true,
        poster: '',
        preload: 'auto'
        // 其他video.js选项...
      },
      activeName: 'first',
      fit: 'cover',
      navUrl: require('@assets/images/index/lunBo.png'),
      src: require('@assets/images/index/chanping2.png'),
      // 产品展示
      url: require('@assets/images/index/chanping.png'),
      url1: require('@assets/images/index/chanping1.png'),
      url2: require('@assets/images/index/chanping2.png'),
      // 采集产品
      gatherUrl: require('@assets/images/index/caiji.png'),
      carouselList: [],
      carouselParams: {
        type: 1
      },
      visitorIp: null
    }
  },
  created () {
  },
  mounted () {
    this.selectBanner()
    this.fetchRealIP()
  },
  methods: {
    async fetchRealIP () {
      try {
        const response = await axios.get('https://gdlsfw.com/prod-api/web/visitLog/visitor-ip')
        this.visitorIp = response.data.ip
        console.log(this.visitorIp)
      } catch (error) {
        console.error('获取失败:', error)
        this.visitorIp = '未知'
      }
    },
    daohang (raw) {
      if (raw.newsId === undefined || raw.newsId === '' || raw.newsId === null) {
      } else {
        this.$router.push({
          path: '/textContent',
          query: {
            id: raw.newsId,
            type: 2
          }
        })
      }
    },
    // 解决方案按钮
    navigateToprogramme () {
      window.location.href = '/programme'
    },
    /** 轮播图 */
    selectBanner () {
      let that = this
      let tabId = '1905457583972433922'
      findBanner(tabId).then(res => {
        that.carouselList = res.data
      })
    },
    /** tab */
    handleClick (tab, event) {
      console.log(tab, event)
    }
  }
}
</script>
